#version 300 es
/*
* Preprocessed + Optimized from './chromatic-aberration.frag'
* [Embedded string is compressed]
*/
precision mediump float;
precision highp int;

uniform mediump sampler2D uTexture;
uniform float red;
uniform vec4 uInputSize;
uniform float u_intensity;
uniform float green;
uniform float blue;

in vec2 vTextureCoord;
layout(location = 0) out vec4 fragColor;

void main()
{
    fragColor = vec4(texture(uTexture, vTextureCoord + ((vec2(red) / uInputSize.xy) * u_intensity)).x, texture(uTexture, vTextureCoord + ((vec2(green) / uInputSize.xy) * u_intensity)).y, texture(uTexture, vTextureCoord + ((vec2(blue) / uInputSize.xy) * u_intensity)).z, texture(uTexture, vTextureCoord).w);
}
